import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {TranslateService} from '@ngx-translate/core';
import {ActionsSubject, Store} from '@ngrx/store';
import {Subscription} from 'rxjs';
import {GroupActions, GroupActionsEnum} from '@store/group';
import {RoleEnum} from '@core/security/enum/role.enum';
import {ofType} from '@ngrx/effects';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

export interface GroupsDialogDataInterface {
    userId: number;
    groupId: number;
}

@Component({
    selector: 'app-user-groups-dialog',
    templateUrl: './user-groups-dialog.component.html',
    styleUrls: ['./user-groups-dialog.component.scss'],
})
export class UserGroupsDialogComponent implements OnDestroy {
    #subscriptions: Subscription[] = [];

    readonly buttonType = ButtonTypeEnum;

    readonly roleEnum = RoleEnum;

    groupId!: number;

    userId!: number;

    isMobile: boolean = false;

    public constructor(
        actionsSubject: ActionsSubject,
        protected readonly snackBar: MatSnackBar,
        private dialogRef: MatDialogRef<UserGroupsDialogComponent>,
        private translateService: TranslateService,
        private store: Store,
        breakpointObserver: BreakpointObserver,
        @Inject(MAT_DIALOG_DATA) public dialogData: GroupsDialogDataInterface,
    ) {
        if (dialogData) {
            this.userId = this.dialogData.userId;
            this.groupId = this.dialogData.groupId;
        }

        this.#subscriptions.push(
            actionsSubject.pipe(ofType(GroupActionsEnum.RemoveGroupUserSuccess)).subscribe(() => this.#handleGroupUserRemoveSuccess()),
        )

        this.isMobile = breakpointObserver.isMatched(Breakpoints.XSmall);
    }

    ngOnDestroy(): void {
        this.#subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    onSubmit(): void {
        if (this.groupId && this.userId) {
            this.store.dispatch(GroupActions.removeGroupUser({groupId: this.groupId, userId: this.userId}));
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    #handleGroupUserRemoveSuccess(): void {
        this.snackBar.open(this.translateService.instant('groups.removeStudentFromGroupValidation'), 'success', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
        });

        this.dialogRef.close();
    }
}
